import Raven from "raven-js";
import configs from "./utils/configs";
import { getCookieToken } from "./utils/get-auth-user";
import * as gtag from "./gtag";
import { getCookie } from "./react-components/cookieUtils"; // Assuming cookieUtils is in react-components

const telemetryQueue = [];
let cookieConsentApproved = false;

// Placeholder function to check for tracking consent
function hasTrackingConsent() {
  const consentCookie = getCookie("cookie_consent_level");
  if (consentCookie) {
    try {
      const consentLevel = JSON.parse(decodeURIComponent(consentCookie));
      return consentLevel.tracking === true;
    } catch (e) {
      console.error("Error parsing cookie consent level:", e);
      return false;
    }
  }
  return false;
}

export default async function registerTelemetry(trackedPage, trackedTitle) {
  const sentryDsn = configs.SENTRY_DSN;
  const gaTrackingId = configs.GA_TRACKING_ID;

  if (sentryDsn && !Raven.isSetup()) {
    Raven.config(sentryDsn).install();
  }

  if (gaTrackingId) {
    if (cookieConsentApproved || hasTrackingConsent()) {
      gtag.initialize(gaTrackingId, trackedPage, trackedTitle);
    } else {
      telemetryQueue.push({ trackedPage, trackedTitle });
    }
  }
}

export function processQueuedTelemetry() {
  cookieConsentApproved = true;
  const gaTrackingId = configs.GA_TRACKING_ID;
  if (gaTrackingId) {
    while (telemetryQueue.length > 0) {
      const { trackedPage, trackedTitle } = telemetryQueue.shift();
      gtag.initialize(gaTrackingId, trackedPage, trackedTitle);
    }
  }
}


export function registerUserAttendedThePresentation(user_id) {
  const url = configs["CUSTOM_API_URL"] + "/register-user-attended-presentation";

  const cookie = getCookieToken();

  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${cookie}`,
      Accept: "application/json"
    },
    body: JSON.stringify({
      user_id: user_id,
      url: window.location.pathname
    })
  }).catch(() => {});
}
